import React from 'react';

const ContactEmail = ({className}) => (
  <svg className={className} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1858_1058)">
      <path fillRule="evenodd" clipRule="evenodd" d="M15.2911 30.8594C23.5754 30.8594 30.291 24.1437 30.291 15.8595C30.291 7.57505 23.5754 0.859375 15.2911 0.859375C7.00687 0.859375 0.291016 7.57505 0.291016 15.8595C0.291016 24.1437 7.00687 30.8594 15.2911 30.8594Z" fill="#ADB8FA"/>
      <rect x="6.57245" y="8.90448" width="18.4998" height="13.8015" rx="2.76031" fill="#ADB8FA" stroke="#A81515" strokeWidth="1.8402"/>
      <rect x="6.57245" y="8.90448" width="18.4998" height="13.8015" rx="2.76031" fill="white" stroke="#ADB8FA" strokeWidth="1.8402"/>
      <path d="M6.80362 9.43702L16.2644 17.1855" stroke="#ADB8FA" strokeWidth="1.8402"/>
      <path d="M24.9375 9.43359L15.3807 17.1821" stroke="#ADB8FA" strokeWidth="1.8402"/>
      <path d="M6.80335 22.1738L12.401 14.503" stroke="#ADB8FA" strokeWidth="1.8402"/>
      <path d="M19.4355 14.5L25.0332 22.0591" stroke="#ADB8FA" strokeWidth="1.8402"/>
    </g>
    <defs>
      <clipPath id="clip0_1858_1058">
        <rect width="34.9639" height="34.9639" fill="white" transform="translate(0.291016 0.859375)"/>
      </clipPath>
    </defs>
  </svg>

);

export default ContactEmail;
